module.exports = __webpack_public_path__ + "static/media/bluehero.5321bca8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/bluehero.webp
// module id = 747
// module chunks = 0